import styled from 'styled-components';
import { Button } from 'components';

export const SvodAndDtoOrTvodButtonsStyled = styled.div`
  position: relative;
`;

export const ColumnWrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const TwoButtonsWrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
`;

export const StyledButton = styled(Button)`
  margin-right: 10px;
`;
